export default {
  form: {
    header: {
      label: 'Cabeçalho',
      placeholder: 'Cabeçalho',
    },
    sub_header: {
      label: 'Subcabeçalho',
      placeholder: 'Subcabeçalho',
    },
    description: {
      label: 'Descrição',
      placeholder: 'Descrição',
    },
    qr_code_header: {
      label: 'Cabeçalho da caixa UI',
      placeholder: 'Cabeçalho da caixa UI',
    },
    qr_code_description: {
      label: 'Descrição da caixa UI',
      placeholder: 'Descrição da caixa UI',
    },
    footer: {
      label: 'Texto do rodapé',
      placeholder: 'Introduza o texto do rodapé',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Selecionar URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Cor primária',
    },
    background_color: {
      label: 'Cor de fundo',
    },
    logo: {
      label: 'Logótipo',
    },
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar o folheto',
  },
};
